import { Injectable, inject } from '@angular/core';
import { MapControlsActions, MapService } from '@navfleet/client/map/domain/data-access';
import { FeatureCollection } from '@navfleet/shared/map/domain/models';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs';

@Injectable()
export class MapVesselPositionWeatherEffects {
    private readonly actions$ = inject(Actions);
    private readonly mapService = inject(MapService);

    public readonly cleanUpSimulation$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(MapControlsActions.cleanUpSimulation),
                tap(({ mapId }) =>
                    this.mapService.setGeoJSONSourceData(mapId, 'GhostVesselPosition', new FeatureCollection())
                )
            ),
        { dispatch: false }
    );
}
